import axios from 'axios';
import { API_URL } from '../config/apiConfig';

/**
 * Get user's saved class filter preferences
 * @param {number} affiliateId 
 * @returns {Promise<string[]>} Array of training types
 */
export const getUserClassFilter = async (affiliateId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/user-class-filter`, {
            params: { affiliateId },
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        return response.data.trainingTypes || [];
    } catch (error) {
        console.error('Error fetching user class filter:', error);
        return [];
    }
};

/**
 * Save user's class filter preferences
 * @param {number} affiliateId 
 * @param {string[]} trainingTypes 
 * @returns {Promise<boolean>} Success status
 */
export const saveUserClassFilter = async (affiliateId, trainingTypes) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${API_URL}/user-class-filter`,
            {
                affiliateId,
                trainingTypes
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data.success || false;
    } catch (error) {
        console.error('Error saving user class filter:', error);
        return false;
    }
};
